<template>
  <div class="vertically-center-content">Slider</div>
</template>

<script>
export default {
 name: "HomeSlider.vue"
}
</script>

<style scoped>
div {
  height: 100%;
}

/* Temporary */
.vertically-center-content {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}
</style>
